import Row from 'antd/es/grid/row'
import Col from 'antd/es/grid/col'
import { IdeyaButton } from '../../../common/antd/ideya-button.tsx'
import { BarChartOutlined } from '@ant-design/icons'
import { useState } from 'react'
import Drawer from 'antd/es/drawer'
import { Dashboard } from '../../summary/dashboard.tsx'
import { useIsMobile } from '../../../common/hooks/use-is-mobile.ts'

interface StatisticsActionColumnProps {
  data: { bookId: string; userName: string; firmName: string }
}

export const StatisticsActionColumn: React.FC<StatisticsActionColumnProps> = ({
  data,
}) => {
  const [open, setOpen] = useState<boolean>(false)
  const [showDashboard, setShowDashboard] = useState<boolean>(false)
  const isMobile = useIsMobile(768)

  // Only show dashboard after drawer is fully rendered
  const handleAfterOpenChange = (visible: boolean) => {
    setShowDashboard(visible)
  }

  if (!data) return <></>

  return (
    <>
      <Row gutter={[8, 0]}>
        <Col>
          <IdeyaButton
            icon={<BarChartOutlined />}
            onClick={() => setOpen(true)}
          />
        </Col>
      </Row>
      <Drawer
        open={open}
        onClose={() => setOpen(false)}
        width={isMobile ? '100%' : '75%'}
        placement={'right'}
        title={`Dashboard for ${data.userName}_${data.firmName}`}
        destroyOnClose
        style={{
          background: `var(--background-image)`,
        }}
        afterOpenChange={handleAfterOpenChange}
      >
        {showDashboard && <Dashboard bookId={data.bookId} />}
      </Drawer>
    </>
  )
}
